var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0784 17.8886H6.91677C3.02969 17.8886 1.36719 16.2261 1.36719 12.3391V12.2361C1.36719 8.72114 2.7526 7.02697 5.85594 6.73406C6.1726 6.71031 6.47344 6.94781 6.5051 7.27239C6.53677 7.59697 6.29927 7.88989 5.96677 7.92156C3.48094 8.15114 2.55469 9.32281 2.55469 12.2441V12.347C2.55469 15.5691 3.69469 16.7091 6.91677 16.7091H12.0784C15.3005 16.7091 16.4405 15.5691 16.4405 12.347V12.2441C16.4405 9.30697 15.4984 8.13531 12.9651 7.92156C12.6405 7.88989 12.3951 7.60489 12.4268 7.28031C12.4584 6.95573 12.7355 6.71031 13.068 6.74197C16.2189 7.01114 17.628 8.71323 17.628 12.252V12.3549C17.628 16.2261 15.9655 17.8886 12.0784 17.8886Z",
    fill: "url(#paint0_linear_867_392)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.6478C9.17542 12.6478 8.90625 12.3787 8.90625 12.0541V1.85742C8.90625 1.53284 9.17542 1.26367 9.5 1.26367C9.82458 1.26367 10.0938 1.53284 10.0938 1.85742V12.0541C10.0938 12.3866 9.82458 12.6478 9.5 12.6478Z",
    fill: "url(#paint1_linear_867_392)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50167 13.5329C9.35125 13.5329 9.20083 13.4775 9.08208 13.3588L6.43 10.7067C6.20042 10.4771 6.20042 10.0971 6.43 9.8675C6.65958 9.63792 7.03958 9.63792 7.26917 9.8675L9.50167 12.1L11.7342 9.8675C11.9638 9.63792 12.3438 9.63792 12.5733 9.8675C12.8029 10.0971 12.8029 10.4771 12.5733 10.7067L9.92125 13.3588C9.8025 13.4775 9.65208 13.5329 9.50167 13.5329Z",
    fill: "url(#paint2_linear_867_392)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_392",
    x1: 17.628,
    y1: 12.3105,
    x2: 1.36719,
    y2: 12.3105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_867_392",
    x1: 10.0938,
    y1: 6.95575,
    x2: 8.90625,
    y2: 6.95575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_867_392",
    x1: 12.7455,
    y1: 11.6141,
    x2: 6.25781,
    y2: 11.6141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A058"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.06b9e48f159ffe1736b8058ca909e0aa.svg";
export { ForwardRef as ReactComponent };